import * as yup from 'yup'

export const validateCreatePriceList = yup.object().shape({
    name: yup
    .string()
    .required('Campo requerido.')
    .min(3, 'El NOMBRE debe tener más de 2 caracteres'),
})
